module.exports = __webpack_public_path__ + "static/media/iphone-solid.a891e893.png";